var SLIDE_TRANSITION = {
    EASE: 'cubic-bezier(0.46,0.1,0.25,1)',
};
export default SLIDE_TRANSITION;
//# sourceMappingURL=behaviourParams_gallery_horizontal_slideTransition.js.map